import type { PostHogConfig } from "posthog-js";
import { filterClaimTelemetry } from "./claim-telemetry";

/**
 * PostHog client options for the consumer app.
 *
 * The consumer app renders income, savings, debts, buying power and credit
 * bands, so analytics must never carry rendered text (SEC-43):
 *
 * - Session replay is off in code. Turning it on in the PostHog dashboard
 *   does nothing while `disable_session_recording` is set.
 * - If replay is ever started anyway, every input and every text node is
 *   masked (`maskTextSelector: "*"`).
 * - Autocapture keeps clicks and element structure but drops `$el_text` and
 *   element attribute values, which can hold a displayed dollar figure.
 */
export function consumerPostHogOptions(apiHost: string | undefined): Partial<PostHogConfig> {
  return {
    api_host: apiHost,
    autocapture: true,
    before_send: filterClaimTelemetry,
    capture_pageview: "history_change",
    capture_pageleave: true,
    disable_session_recording: true,
    session_recording: {
      maskAllInputs: true,
      maskTextSelector: "*",
    },
    mask_all_text: true,
    mask_all_element_attributes: true,
  };
}
